import type { CohortConditionSummary } from "@unbox/api";
import { Button } from "@/components/base/buttons/button";
import { useCurrency } from "@/hooks/use-currency";
import { formatConditionSummary } from "@/lib/creator-cohorts/condition-summary";
import { pluralize } from "@/utils/text";

type CohortRuleCellProps = {
  conditions: CohortConditionSummary[];
  onInspect: (ruleId: string) => void;
};

export const CohortRuleCell = ({ conditions, onInspect }: CohortRuleCellProps) => {
  const currency = useCurrency();
  const [first, ...rest] = conditions;
  const summary = formatConditionSummary(first, currency);

  if (!summary) return <span className="text-secondary">—</span>;

  return (
    <div className="flex items-center gap-2">
      <button type="button" className="text-secondary hover:underline" onClick={() => onInspect(first.ruleId)}>
        {summary.value}
        {summary.unit ? <span className="text-quaternary"> {summary.unit}</span> : null}
      </button>
      {rest.length > 0 && (
        <Button
          color="secondary"
          size="sm"
          aria-label={`Show ${pluralize(rest.length, "more condition", "more conditions")}`}
          onClick={() => onInspect(rest[0].ruleId)}
        >
          +{rest.length}
        </Button>
      )}
    </div>
  );
};
